module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Cooking/KnifeAndFork2-f503d5cf333c54eb9ed5faf25837a6e8.svg";